import styles from './SalaryType.less';

import { head, filter, get, map } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ScreenReaderOnly } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

export default class SalaryType extends Component {
  static propTypes = {
    salaryTypes: PropTypes.arrayOf(
      PropTypes.shape({
        isActive: PropTypes.bool.isRequired,
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        refineParams: PropTypes.object
      })
    ).isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const { salaryTypes, className, ...props } = this.props;
    const activeSalaryType = head(filter(salaryTypes, 'isActive'));
    const activeValue = get(activeSalaryType, 'value');
    const listClasses = classnames({
      [styles.list]: true,
      [styles.annualIsActive]: activeValue === 'annual',
      [styles.hourlyIsActive]: activeValue === 'hourly'
    });

    return (
      <section {...props} className={classnames(styles.root, className)}>
        <ScreenReaderOnly>
          <h1>Salary type</h1>
        </ScreenReaderOnly>
        <ul role="radiogroup" className={listClasses}>
          {map(salaryTypes, salaryType => {
            const { isActive, value, label, refineParams } = salaryType;

            // We always provide a link here, even for the selected item
            // so screen readers maintain radio button selection context
            return (
              <li className={styles.item} key={value} role="presentation">
                <NavLink
                  role="radio"
                  aria-label={`Salary type, ${label}`}
                  aria-checked={isActive}
                  location={{
                    pathname: !isActive ? '/jobs' : null,
                    query: refineParams
                  }}
                  className={isActive ? styles.activeLink : styles.link}
                  {...(isActive
                    ? { 'data-automation': 'refineActiveSalaryType' }
                    : {})}
                >
                  {label}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </section>
    );
  }
}
